import React, { FC } from 'react';
import { dateFormatter } from 'common/helpers/date.helper';
import { WarningCircle } from 'common/svg';
import { MetricOverview } from 'common/components/MetricOverview';
import { EMetricType } from 'common/models/commonModel';
import { ITrackStoreSummary } from 'entities/TrackStore/TrackStore.models';

interface IComponentProps {
  summary: ITrackStoreSummary | null;
}

export const TrackStoreSummary: FC<IComponentProps> = ({ summary }) => {
  return (
    <div className="track-store-summary">
      <div className="mb-5 flex flex-align-center flex-justify-between">
        <div className="ff-medium fs-xxs">{dateFormatter(summary?.lastUpdatedAt, 'MMM D, YYYY (dddd)')}</div>
        <WarningCircle className="icon-gray" />
      </div>

      <div>
        <div className="mb-4">
          <MetricOverview type={EMetricType.Sales} metric={summary?.sales} />
        </div>
        <div className="mb-4">
          <MetricOverview type={EMetricType.TransactionCount} metric={summary?.transactionCount} />
        </div>
        <div className="mb-4">
          <MetricOverview type={EMetricType.AverageCheck} metric={summary?.averageCheck} />
        </div>
      </div>
    </div>
  );
};
